import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  lang,
  handleCancelClick,
  increment,
  counter,
  setLangId,
  langOptions,
  langLevel,
}) => {
  const [newLang, setNewLang] = useState(lang);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewLang((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "language/" + newLang.id + "/",
          newLang,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setLangId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    updateData();
  };
  return (
    <tr>
      <td>
        <select name="lang" onChange={handleChange} value={newLang.lang}>
          <option key="0" value="" selected>
            בחר שפה
          </option>
          {langOptions?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>
      <td>
        <select name="read" onChange={handleChange} value={newLang.read}>
          <option key="0" value="" selected>
            בחר רמה
          </option>
          {langLevel?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>
      <td>
        <select name="write" onChange={handleChange} value={newLang.write}>
          <option key="0" value="" selected>
            בחר רמה
          </option>
          {langLevel?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>
      <td>
        <select name="speek" onChange={handleChange} value={newLang.speek}>
          <option key="0" value="" selected>
            בחר רמה
          </option>
          {langLevel?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>

      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
